export const Logo = ({ className = "", size = "h-7" }) => (
  <img src="/images/pluk-wordmark.png" alt="PLUK" className={`${size} w-auto select-none ${className}`} draggable="false" />
);
